import { Link } from "gatsby";
import React, { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../Button/Button";
import { getSlugWithLang } from "../../../shared/utils/getSlugWithLang";
import { useLayout } from "../../LayoutContext";

type NavbarLinksProps = PropsWithChildren<{
  desktop?: boolean;
  closeSidebar?: () => void;
}>;

const NavbarLinks: React.FC<NavbarLinksProps> = (props: NavbarLinksProps) => {
  const { t, i18n } = useTranslation("global");
  const { navbarLinks } = useLayout();

  const handleLinkClick = () => {
    if (props.closeSidebar) {
      props.closeSidebar();
    }
  };

  return (
    <div className={`m-navbarlinks ${props.desktop ? "m-navbarlinks--desktop" : "m-navbarlinks--sidebar"}`}>
      {navbarLinks?.map((item, index) => (
        <Link
          key={index}
          activeClassName={"navbarlinks__item--active"}
          className={`navbarlinks__item`}
          to={getSlugWithLang(item.slug, i18n.language)}
          onClick={handleLinkClick} // Llama a la función al hacer clic en el enlace
        >
          {item.name}
        </Link>
      ))}
      {!props.desktop && <Button actionLink={"/contacto/"}>{t("Contacto")}</Button>}
    </div>
  );
};

export default NavbarLinks;
